const baseURL = 'https://segmet.algorix.com.ar/';

export default baseURL;
